<div *ngIf="!mobile" class="top" [ngStyle]="{ color: secondaryColor, 'background-color': primaryColor }">
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div *ngIf="mobile" class="top">
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>west</mat-icon>
  </button>
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
</div>
<div class="area">

  <div class="video-container">
    <iframe
      [src]="url | safe"
      frameborder="0"
      allow="accelerometer; encrypted-media; gyroscope; autoplay; allow-top-navigation; allow-scripts;
      allow-forms; allow-same-origin; allow-popups; picture-in-picture; camera; microphone; allow-downloads"
      allowfullscreen
    ></iframe>
  </div>
</div>
